/**
 * @Description:
 * @Author: huage
 * @Date: 2020/9/17
 */
export default {
    roleList: {
        "application": "应用",
        "roleList": "角色列表",
        "roleName": "角色名称",
        "roleNumber": "角色编号",
        "applicationExamples": "应用实例",
        "founder": "创建人",
        "creationTime": "创建时间",
        "remarks": "备注",
        "numberOfUsersAssociatedWithRoles": "角色关联用户数",
        "state": "状态",
        "edit": "编辑",
        "disable": "禁用",
        "delete": "删除",
        "resourceInformation": "资源信息",
        "pageElements": "页面元素",
        "pageElementName": "页面元素名称",
        "pageElementNumber": "页面元素编码",
        "updateTime": "更新时间",
        "addRole": "新增角色",
        "editRole": "编辑角色",
        "roleInformation": "角色信息",
        "classify": "分类",

        "message1": "分配资源不能为空",
        "message2": "保存成功",
        "placeholder1": "角色名称不能为空",
        "placeholder2": "角色名称限20字符以内",
        "placeholder3": "创建后不可修改",
        "placeholder4": "请输入数字字母或两者组合，限20字符以内",

        "text1": "资源信息",
      }
};


// WEBPACK FOOTER //
// ./src/config/langs/zh_CN/roleList.js